// localStorage.setItem('preCart', JSON.stringify(LocalStoragePreCart));
	window.addEventListener('DOMContentLoaded', function() {    
		$(document).ready(function() {
			$( ".buttons__link--wishlist-not-login" ).on( "click", function(e) {

				let productTitle = $('.product-single__title').text();
        		localStorage.setItem('swym-login-analitics', productTitle);

				// Get Object with product data for addToWishList() function
				let wishlistApiData = getWishlistApiData();

				
        
        // add wishlist object for addToWishList() function to the localStorage
        function pushItemToLocalStorage(wishlistApiData) {
		      localStorage.setItem('swym-login-wishlist', JSON.stringify(wishlistApiData));          
        }

        pushItemToLocalStorage(wishlistApiData);



        setTimeout(() => {
            let localStorageWishlist = JSON.parse(localStorage.getItem('swym-login-wishlist')) || {};
            if (jQuery.isEmptyObject(localStorageWishlist) == false) {
              window.location.replace("/account/login");              
            } else {              
              pushItemToLocalStorage(wishlistApiData);
            }
        }, 200, wishlistApiData)
				function getWishlistApiData() {			
					let productForm = $('form.product-form');
					let variantsSelect  = $(productForm).find('.product-form__variants');
					let variantSelected = $(variantsSelect).find('option:selected');
					let variantID = $(variantSelected).val();
					let variantTitle = $(variantSelected).text();					
					let variantPrice = $(variantSelected).attr('data-variant-regular-price');

					let productID = $(variantsSelect).attr('data-product-id');
					
					let pageUrl = window.location.origin + window.location.pathname + '?variant=' + variantID;
					
					// imageUrl must be unic for each variant. Now for all vraiants image is same;
					var imageUrl = $('.product__slider').find('.product-single__media-wrapper img').attr('src');
          console.log($('.product__slider'));
          console.log($('.product__slider').find('.product-single__media-wrapper img'));
					
					// If src has image variant - remove it
					if (imageUrl.includes("?")) {
						imageUrl = imageUrl.split('?');
						imageUrl = imageUrl[0];				
					}	

					let wishlistApiData = {
							"epi": variantID,
							"dt": productTitle,
							"du": pageUrl,
							"empi": productID,
							"iu" : imageUrl,
							"pr": variantPrice,
							"variants": [{[variantTitle]: variantID}]
						}
					
					return wishlistApiData				
				}
		
			});
		});    
	})